import React from "react";
import { Box, Typography } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import { useStyles } from "./stepperPayment.styles";

const StepperPayment = ({ activeStep, steps }) => {
  const classes = useStyles();

  return (
    <Box className={classes.stepperContainer}>
      <Typography className={classes.logo}>eGreen</Typography>

      <Box className={classes.stepsRow}>
        <Box className={activeStep > 0 ? classes.stepDone : classes.stepActive}>
          <Box
            className={
              activeStep > 0 ? classes.circleDone : classes.circleActive
            }
          >
            {activeStep > 0 ? <CheckIcon style={{ fontSize: 16 }} /> : "1"}
          </Box>
          <Typography className={classes.stepText}>
            {steps[0] || "BILLING"}
          </Typography>
        </Box>

        <Box className={classes.stepLine} />

        <Box
          className={
            activeStep === 1 ? classes.stepActive : classes.stepInactive
          }
        >
          <Box
            className={
              activeStep === 1 ? classes.circleActive : classes.circleInactive
            }
          >
            2
          </Box>
          <Typography
            className={classes.stepText}
            style={{
              color: activeStep === 1 ? "#06e89f" : "rgba(255,255,255,0.4)",
              fontWeight: activeStep === 1 ? 700 : 500,
            }}
          >
            {steps[1] || "PAYMENT"}
          </Typography>
        </Box>
      </Box>

      <Box style={{ width: 64 }} />
    </Box>
  );
};

export default StepperPayment;
